import { ChangeEvent, FormEvent } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { MessageTemplateContentValidationErrors } from "@idw-types/common/validation/message-template/message-template-validation-errors";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessageTemplateContentFormSection } from "@containers/message-template-details/message-template-details-component/message-template-content-tab/message-template-content-form-section/message-template-content-form-section";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { MessageTemplatePreviewContainer } from "@containers/message-template-details/message-template-details-component/message-template-preview-container/message-template-preview-container";

type MessageTemplateContentFormProps = {
    state: FormattedMessageTemplate;
    requestInProgress: boolean;
    selectedLanguage: LocaleTypes;
    validationErrors: MessageTemplateContentValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setState: (state: FormattedMessageTemplate) => void;
    onBackClicked: () => void;
    handleSubmit: (event: FormEvent) => void;
};

export const MessageTemplateContentForm = (props: MessageTemplateContentFormProps) => {
    const {
        state,
        requestInProgress,
        selectedLanguage,
        validationErrors,
        setState,
        onBackClicked,
        handleSubmit
    } = props;

    const handleUpdateTemplate = (event: ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            template: event.target.value
        });
    };

    const resource = resources.modals.addMessageTemplate;

    return (
        <Form onSubmit={handleSubmit}>
            <Modal.Header id={"add-message-template-title"} closeButton>
                <Modal.Title>{resource.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ThemingConfigurationContainer>
                     <ThemingFormContainer>
                        <MessageTemplateContentFormSection
                            isDisabled={false}
                            labelWidth={LabelWidthTypes.MEDIUM}
                            state={state}
                            validationErrors={validationErrors}
                            handleUpdateTemplate={handleUpdateTemplate}
                        />
                    </ThemingFormContainer>
                    <MessageTemplatePreviewContainer
                        state={state}
                        selectedLanguage={selectedLanguage}
                    />
                </ThemingConfigurationContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-message-template-back-button" variant="secondary" onClick={onBackClicked}>{resources.common.buttons.back.label}</Button>
                <ButtonWithSpinner
                    id="add-message-template-next-to-variables-button"
                    disabled={requestInProgress || validationErrors.count > 0}
                    hideSpinner={validationErrors.count > 0}
                    variant="primary"
                    type={ButtonTypes.SUBMIT}
                    label={resource.buttons.nextToVariables.label}
                />
            </Modal.Footer>
        </Form>
    );
};